import { cx, css } from "emotion";
import React from "react";
import { useForm } from "react-hook-form";
import AuthService from "../../../Services/AuthService/AuthService";
import md5 from "md5";
import UsersService from "../../../Services/UsersService/UsersService";
import { notifUtils } from "../../../components/NotifUtils/NotifUtils";
import { TrendingUpRounded } from "@material-ui/icons";
import VisibilityIcon from "@material-ui/icons/Visibility";
import VisibilityOffIcon from "@material-ui/icons/VisibilityOff";

const user = JSON.parse(localStorage.getItem("user"));
const Security = (props) => {
  const { isMobile } = props;
  const [loading, setLoading] = React.useState(false);
  const [errorPassword, setErrorPassword] = React.useState(false);
  const [wrongPassword, setWrongPassword] = React.useState("");
  const { register, handleSubmit, formState: {errors, isValid}, watch } = useForm({
    mode: "all",
    reValidateMode: "onChange",
  });
  const [passwordVisible, setPasswordVisible] = React.useState({
    inputComponent: {
      oldPassword: false,
      newPassword: false,
      confirmPasssword: false,
    },
  });

  const togglePasswordVisible = (field) => {
    const { inputComponent } = passwordVisible;
    inputComponent[field] = !inputComponent[field];
    setPasswordVisible({ inputComponent });
  };

  const resetPasswordVisible = (field) => {
    let { inputComponent } = passwordVisible;
    inputComponent = {
      oldPassword: false,
      newPassword: false,
      confirmPasssword: false,
    };
    setPasswordVisible({ inputComponent });
  };

  const updateUserData = (field, value) => {
    user[field] = value;
    localStorage.setItem("user", JSON.stringify(user));
  };

  const onSubmit = (data, e) => {
    const params = [
      {
        op: "replace",
        path: "/password",
        value: md5(data.newPassword.toString()),
      },
      {
        op: "replace",
        path: "/default_password",
        value: false,
      },
    ];

    const id = user?.id;
    UsersService.patch(id, params).then((response) => {
      setLoading(false);
      e.target.reset();
      if (response.status === 200) {
        notifUtils("Success update password", "success");
        resetPasswordVisible();

        if (user?.default_password) {
          updateUserData("default_password", false);
          window.location.href = "/home";
        }
      }
    });
  };

  const onCheckPassword = (data, e) => {
    setLoading(true);
    let params = {};
    params.password = md5(data.oldPassword.toString());
    AuthService.checkPassword(params)
      .then((response) => {
        if (response.status === 200) {
          onSubmit(data, e);
        }
      })
      .catch((error) => {
        const response = error.response;
        setLoading(false);
        setWrongPassword(data.oldPassword);
        if (response.status === 404) {
          setErrorPassword(true);
        }
      });
  };

  return (
    <div
      className={cx(
        css`
          ${isMobile ? "width: 100%;" : "width: 400px"}
        `,
        "px-3 py-2"
      )}
    >
      <h2 className="font-20 font-bold">Security</h2>
      {user?.default_password && (
        <p className="font-12 text-danger border-left-4-error pl-2">
          Password anda saat ini dibuat oleh sistem. Anda harus mengubah untuk
          bisa melanjutkan mengakses menu lain.
        </p>
      )}
      <form
        className="mt-3"
        onSubmit={handleSubmit(onCheckPassword)}
        noValidate
      >
        <div className="form-group">
          <label className="d-block font-bold font-12">{user?.default_password ? "Default Password" : "Password Lama"}</label>
          <div className="input-group">
            <input
              type={passwordVisible.inputComponent.oldPassword ? "text" : "password"}
              className={
                errors?.password
                  ? "form-control rounded-8px border-1-error font-12 bg-gray-300"
                  : "form-control rounded-8px border-0 font-12 bg-gray-300"
              }
              name="oldPassword"
              onChange={() => setWrongPassword("")}
              {...register("oldPassword",{
                required: user?.default_password ? "Masukkan default password" : "Masukkan password lama",
              })}
            />
            <span
              className={cx(
                css`
                  border-top-right-radius: 8px;
                  border-bottom-right-radius: 8px;
                `,
                "d-flex justify-content-center align-items-center input-group-addon px-2 cursor-pointer bg-gray-300 border-0"
              )}
              onClick={() => togglePasswordVisible("oldPassword")}
            >
              {passwordVisible.inputComponent.oldPassword && <VisibilityIcon />}
              {!passwordVisible.inputComponent.oldPassword && <VisibilityOffIcon />}
            </span>
          </div>
          {errors.oldPassword && (
            <p className="text-danger font-10 mt-2 pl-3 border-left-4-error">
              {errors.oldPassword?.message}
            </p>
          )}
          {errorPassword && wrongPassword !== "" && (
            <p className="text-danger font-10 mt-2 pl-3 border-left-4-error">
              Password lama anda salah
            </p>
          )}
        </div>
        <div className="form-group">
          <label className="d-block font-bold font-12">Password Baru</label>
          <div className="input-group">
            <input
              type={passwordVisible.inputComponent.newPassword ? "text" : "password"}
              className={
                errors?.password
                  ? "form-control rounded-8px border-1-error font-12 bg-gray-300"
                  : "form-control rounded-8px border-0 font-12 bg-gray-300"
              }
              name="newPassword"
              onChange={() => setWrongPassword("")}
              {...register("newPassword",{
                required: "Masukkan password baru",
              })}
            />
            <span
              className={cx(
                css`
                  border-top-right-radius: 8px;
                  border-bottom-right-radius: 8px;
                `,
                "d-flex justify-content-center align-items-center input-group-addon px-2 cursor-pointer bg-gray-300 border-0"
              )}
              onClick={() => togglePasswordVisible("newPassword")}
            >
              {passwordVisible.inputComponent.newPassword && <VisibilityIcon />}
              {!passwordVisible.inputComponent.newPassword && <VisibilityOffIcon />}
            </span>
          </div>
          {errors.newPassword && (
            <p className="text-danger font-10 mt-2 pl-3 border-left-4-error">
              {errors.newPassword?.message}
            </p>
          )}
        </div>
        <div className="form-group">
          <label className="d-block font-bold font-12">
            Ulangi Password Baru
          </label>
          <div className="input-group">
            <input
              type={passwordVisible.inputComponent.confirmPasssword ? "text" : "password"}
              className={
                errors?.password
                  ? "form-control rounded-8px border-1-error font-12 bg-gray-300"
                  : "form-control rounded-8px border-0 font-12 bg-gray-300"
              }
              name="confirmPasssword"
              onChange={() => setWrongPassword("")}
              {...register("confirmPasssword",{
                required: "Masukkan konfirmasi password baru",
                validate: (value) =>
                  value === watch("newPassword") ||
                  "Password yang anda ketik beda dengan yang password baru anda",
              })}
            />
            <span
              className={cx(
                css`
                  border-top-right-radius: 8px;
                  border-bottom-right-radius: 8px;
                `,
                "d-flex justify-content-center align-items-center input-group-addon px-2 cursor-pointer bg-gray-300 border-0"
              )}
              onClick={() => togglePasswordVisible("confirmPasssword")}
            >
              {passwordVisible.inputComponent.confirmPasssword && <VisibilityIcon />}
              {!passwordVisible.inputComponent.confirmPasssword && <VisibilityOffIcon />}
            </span>
          </div>
          {errors.confirmPassword && (
            <p className="text-danger font-10 mt-2 pl-3 border-left-4-error">
              {errors.confirmPassword?.message}
            </p>
          )}
        </div>
        <div className="form-group mt-3 text-center">
          {loading && (
            <button
              type="submit"
              className={cx(
                css`
                  width: 200px;
                  padding: 14px 42px !important;
                `,
                "btn bg-blue text-white rounded-8px border-0 font-12"
              )}
              disabled={true}
            >
              SIMPAN
            </button>
          )}
          {!loading && (
            <button
              type="submit"
              className={cx(
                css`
                  width: 200px;
                  padding: 14px 42px !important;
                `,
                isValid
                  ? "btn bg-blue text-white rounded-8px border-0 font-12"
                  : "btn bg-gray-757575 text-white rounded-8px border-0 font-12"
              )}
              disabled={!isValid}
            >
              SIMPAN
            </button>
          )}
        </div>
      </form>
    </div>
  );
};

export default Security;
